import * as preferencesActions from "../actions/preferences/actions";

export const fetchPreferences = (
  dispatch: any,
  userEmail: User.UserData["email"]
): void => {
  dispatch(preferencesActions.fetchPrefRequest({ email: userEmail }));
};
